<template>
	<div class="cart ">
		<div class="flex items-center justify-between pb-[6px] box-border bB-03">
			<div class="flex items-center">
				<div class="navTitle cursor-pointer active text-[#FF0000] font-bold  relative text-[16px] mr-[34px]">
					{{langInfo.head_cart}}({{tableData.length}})
				</div>
			</div>
		</div>
		<div class="py-[15px] box-border">
			<div class="" v-if="tableData.length>0&&isFinish">
				<el-table ref="multipleTable" height="500" class="mb-[30px]" :data="tableData" tooltip-effect="dark"
					style="width: 100%" @select="select" @select-all="selectAll">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column :label="langInfo.commodity" width="160">
						<template slot-scope="scope">
							<el-image class="w-[120px] h-[80px] rounded-[6px]" :src="scope.row.cover_img"
								fit="cover"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="" width="260">
						<template slot-scope="scope">
							<div class="pr-[40px] box-border text-[#545C63] text-[14px]">
								{{scope.row.name}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="address" :label="langInfo['Unit price']" width="140">
						<template slot-scope="scope">
							<div class="text-center text-[16px] text-[#676C73]">
								￥{{scope.row.course_discount}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="num" :label="langInfo['Quantity']" width="140">
						<template slot-scope="scope">
							<div class="flex items-center justify-center">
								<div @click="reduceNum(scope.row)"
									class="w-[24px] h-[24px] cursor-pointer  mr-[6px] text-center leading-[24px] border border-[#E8E8E8] border-solid ">
									<i class="el-icon-minus"></i>
								</div>
								<div class="w-[50px] text-center mr-[6px]">
									{{scope.row.quantity}}
								</div>
								<div @click="addNum(scope.row)"
									class="w-[24px] h-[24px] cursor-pointer text-center leading-[24px] border border-[#E8E8E8] border-solid">
									<i class="el-icon-plus"></i>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="xiaoJi" :label="langInfo['Xiao Ji']">
						<template slot-scope="scope">
							<div class="text-center font-bold text-[20px] text-[#676C73]">
								￥{{scope.row.totalPrice}}
							</div>
						</template>
					</el-table-column>
					<el-table-column fixed="right" :label="langInfo.Operation" width="100">
						<template slot-scope="scope">
							<div class="text-center">
								<el-button @click="handleDelClick(scope.row)" type="text"
									size="small">{{langInfo.delete}}</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="flex items-center justify-between pr-[36px] box-border">
					<div class="pl-[12px] box-border mr-[20px] ">
						<el-checkbox class="" v-model="allChecked" @change="changeChecked"><label
								class="text-[16px] text-[#3894FF]">{{langInfo.all_clecked}}</label></el-checkbox>

						<label class="text-[#676C73] cursor-pointer"
							@click="del_selected()">{{langInfo.delete_selected_product_title}}</label><label>丨</label>
						<label @click="clearCart()"
							class="text-[#676C73] cursor-pointer">{{langInfo.clear_cart}}</label>
					</div>
					<div class="text-[16px] text-[#676C73]">
						{{langInfo['Total price']}}：<label
							class="text-[#FF0000] font-bold text-[18px]">¥{{total_price}}</label>
					</div>
					<div @click="buy_now_btn()"
						class="w-[80px] h-[30px] cursor-pointer leading-[30px] text-center text-white bg-[#FF0000] text-[14px] rounded-[8px]">
						{{langInfo.settlement_tip}}
					</div>
				</div>
			</div>
			<emptyPage v-else-if="tableData.length==0&&isFinish" :title="langInfo.no_data_available"></emptyPage>
		</div>
		<!-- 收银台 -->
		<el-dialog :title="langInfo.checkstand" @close="closeDialog" :visible.sync="payVisible"
			:close-on-click-modal="false" width="40%" top="8vh" center>

			<div v-for="(item,index) in paySelectProduct" :key="index"
				class="bg-white mb-[10px] py-[20px] px-[16px] box-border flex justify-between items-center">
				<div class="flex-1 flex mr-[80px]">
					<el-image class="w-[147px] h-[96px] mr-[16px] rounded-[6px]" :src="item.cover_img"
						fit="cover"></el-image>
					<div class="flex-1 ">
						<div class="mb-[10px]">
							{{item.name}}
						</div>
						<div class="text-[#999999]">
							x{{item.quantity}}
						</div>
					</div>
				</div>
				<div class="text-[20px] text-[#FF0000]">
					¥{{item.totalPrice}}
				</div>
			</div>
			<div class="bg-white mb-[10px]  flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px]  font-bold">
					{{langInfo['Remarks (Optional)']}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.remarks" class="formInput w-full text-[18px]"
						:placeholder="langInfo['enter_remarks_tip']"></el-input>
				</div>
			</div>
			<div class="bg-white mb-[10px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] font-bold">
					{{langInfo.coupon_title}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.couponCode" @change="couponChange" class="formInput w-full text-[18px]"
						:placeholder="langInfo.enter_coupon_tip"></el-input>
				</div>
			</div>
			<div class="bg-white mb-[10px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] font-bold">
					{{langInfo['Invitation Code']}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.invitationCode" @change="inviteCodeChange"
						class="formInput w-full text-[18px]" :placeholder="langInfo['enter_invitation_tip']"></el-input>
				</div>
			</div>
			<div class="bg-white mb-[20px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] flex items-center mr-[50px]">
					<label class="font-bold">{{langInfo['Balance deduction']}}</label> <label
						class="text-[16px] text-[#686C73]">（{{langInfo['account_balance']}}：{{userInfo.money}}）</label>：
				</div>
				<div class="flex-1 flex align-items-center">
					<div class="flex items-center cursor-pointer mr-[40px]" @click="balanceClick(1)">
						{{langInfo['balance_yes']}} <img class="w-[22px] h-[22px] ml-[10px] "
							:src="isBalance==1?selectedImg:selectImg" alt="" srcset="" />
					</div>
					<div class="flex items-center cursor-pointer" @click="balanceClick(2)">
						{{langInfo['balance_no']}} <img class="w-[22px] h-[22px] ml-[10px]"
							:src="isBalance==2?selectedImg:selectImg" alt="" srcset="" />
					</div>
				</div>
			</div>
			<div class="text-[18px] flex items-center mb-[25px]">
				<label class="font-bold">{{langInfo['Actual amount']}}</label> <label
					class="text-[16px] ml-[18px] text-[#FF0000]">¥{{pay_price}}</label>
			</div>
			<div class="text-[18px] font-bold mb-[14px]">
				{{langInfo['Payment method']}}
			</div>
			<div class="mb-[24px] flex items-center ">
				<!-- <div @click="payMethod=5" class="flex  items-center cursor-pointer">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==5?selectedImg:selectImg" alt=""
						srcset="" />
					<label class="text-[#000C16] text-[16px]">{{langInfo['Offline pay']}}</label>
				</div> -->
				<div @click="payMethod=2" class="flex  items-center cursor-pointer mr-[40px]">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==2?selectedImg:selectImg" alt=""
						srcset="" />
					<img src="@/static/image/index08.png" class="w-[110px] h-[40px]" alt="" srcset="" />
				</div>
				<div @click="payMethod=1" class="flex  items-center cursor-pointer">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==1?selectedImg:selectImg" alt=""
						srcset="" />
					<img src="@/static/image/index09.png" class="w-[110px] h-[40px]" alt="" srcset="" />
				</div>
			</div>
			<div @click="nextPay()"
				class="w-[250px] h-[44px] cursor-pointer  mx-auto leading-[44px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
				{{langInfo['Next step']}}
			</div>
		</el-dialog>

		<el-dialog title="微信支付" @close="closeWxDialog" :visible.sync="wxPay" :close-on-click-modal="false" width="40%"
			center top="8vh">
			<div class="w-[250px] h-[250px]   mx-auto  rounded-[4px]  ">
				<img :src="qrcode" class="w-[250px] h-[250px] " alt="" />
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	import lang from '@/store/lang'
	export default {
		components: {

			emptyPage
		},
		data() {
			return {
				// personalCenter/cart
				page: 1,
				limit: 8,
				total: 0,
				otherTable: [],
				tableData: [],
				total_price: 0,
				isFinish: false,
				allChecked: false,
				cartProductId: [],
				selected_count: 0,

				payVisible: false,

				selectImg: require('@/static/image/icon68.png'),
				selectedImg: require('@/static/image/icon69.png'),


				payMethod: 2, //支付类型:1=微信,2=支付宝,4=余额 , 5=线下支付

				paySelectProduct: [], //需要支付的商品

				langInfo: {},
				orderInfo: {
					order_id: '',
					order_no: '',
					total_amount: ''
				},
				pay_order: {
					id: '',
					order_no: '',
					pay_coupon: '',
					pay_money: '',

					payment_status: '',
					payment_time: '',
					payment_type: '',
					total_amount: '',
				},

				isBalance: 1, //余额抵扣
				payInfo: {
					remarks: '', //备注，
					couponCode: '', //优惠券码
					invitationCode: '', //邀请码
					pay_money: '' //余额抵扣
				},
				pay_price: '0.00', //支付金额
				userInfo: {
					money: ''
				},
				qrcode: '',
				wxPay: false,
				jieguo: null,
				order_id: '',
				isAlipay: false
			}
		},
		mounted() {

			clearInterval(this.jieguo)

			this.getdict_data()

			this.getUserInfo()
		},
		destroyed() {
			clearInterval(this.jieguo)
			this.jieguo = null
		},
		methods: {
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					this.get_cart_list()
				}).catch((error) => {
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj


					document.title = this.langInfo.pc_name + '-' + this.langInfo.study_my_cart

				}).catch((error) => {})
			},
			get_cart_list() {
				this.$api.cart_list().then((res) => {
					console.log(res);
					this.tableData = res.data.cart_list
					this.otherTable = res.data.cart_list
					this.total = res.data.total_count
					this.total_price = res.data.total_price
					this.selected_count = res.data.selected_count
					this.isFinish = true
					this.cartProductId = []

					this.tableData.forEach((item, index) => {
						this.cartProductId.push(item.id)
					})
					this.$nextTick(() => {
						if (this.selected_count > 0 && this.tableData.length > 0 && this.selected_count ==
							this.tableData.length) {
							console.log("全选");
							this.allChecked = true
							console.log(this.$refs.multipleTable.toggleAllSelection());
						} else {
							console.log("32323");
							if (this.tableData.length > 0) {
								this.tableData.forEach((item, index) => {
									if (item.is_selected == 1) {
										console.log("item.is_selected===" + item.is_selected);
										this.$refs.multipleTable.toggleRowSelection(item);
									}
								})
							}
						}
					})
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			select(val) {
				console.log(val);
				console.log("val====");
				if (val.length > 0) {
					let selectedId = []
					val.forEach((item, index) => {
						selectedId.push(item.id)
					})
					if (selectedId.length == this.tableData.length) {
						this.allChecked = true
					}

					this.updateSelected(selectedId.toString(), 1)
				} else {
					this.allChecked = false
					this.updateSelected(this.cartProductId.toString(), 0)
				}
			},
			selectAll(val) {
				console.log("全选");
				console.log(val);

				console.log("val====");
				if (val.length > 0) {
					let selectedId = []
					val.forEach((item, index) => {
						selectedId.push(item.id)
					})
					if (selectedId.length == this.tableData.length) {
						this.allChecked = true
					}

					this.updateSelected(selectedId.toString(), 1)
				} else {
					this.allChecked = false
					this.updateSelected(this.cartProductId.toString(), 0)
				}

			},
			// handleSelectionChange(val) {


			// },
			updateSelected(cart_ids, is_selected) {
				this.$api.updateSelected({
					cart_ids: cart_ids,
					is_selected: is_selected,
					type: '2'
				}).then((res) => {
					console.log(res);
					this.countNum()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			countNum() {

				this.$api.cart_list().then((res) => {
					console.log(res);
					this.total = res.data.total_count
					this.total_price = res.data.total_price
					this.selected_count = res.data.selected_count
					this.otherTable = res.data.cart_list


					if (this.selected_count > 0 && this.otherTable.length > 0 && this.selected_count ==
						this.otherTable.length) {
						console.log("全选");
						this.allChecked = true

					} else {
						this.allChecked = false
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			handleDelClick(rows) {
				console.log(rows);
				this.$confirm(this.langInfo.delete_cart_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.addOrEdit({
						course_product_id: rows.course_product_id,
						quantity: 0,
						is_cart: 0,
					}).then((res) => {
						console.log("res.data====");
						this.get_cart_list()
					}).catch((error) => {
						console.log(error.msg);
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch(() => {

				});
			},
			changeChecked(e) {
				console.log(e);
				if (e) {
					this.allChecked = true
					this.$refs.multipleTable.toggleAllSelection()
					this.updateSelected(this.cartProductId.toString(), 1)
				} else {
					this.allChecked = false
					this.$refs.multipleTable.clearSelection()
					this.updateSelected(this.cartProductId.toString(), 0)
				}
			},
			reduceNum(item) {
				if (item.quantity == 0) {
					return
				}
				item.quantity--
				this.countPrice(item)
			},
			addNum(item) {
				item.quantity++
				this.countPrice(item)
			},
			countPrice(item) {
				let allCheck = true
				let total = 0
				let productId = []
				this.$api.addOrEdit({
					course_product_id: item.course_product_id,
					quantity: item.quantity,
					is_cart: 0,
				}).then((res) => {
					console.log("res.data====");
					this.get_cart_list()
				}).catch((error) => {
					console.log(error.msg);
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 删除选中的商品
			del_selected() {
				let select_id = []
				if (this.selected_count == 0) {
					this.$message({
						message: this.langInfo.cart_select_tip,
						type: 'warning'
					})
					return
				}
				if (this.otherTable.length > 0) {
					this.otherTable.forEach((item, index) => {
						if (item.is_selected == 1) {
							console.log("item.is_selected===" + item.is_selected);
							select_id.push(item.id)
						}
					})
				}
				this.$confirm(this.langInfo.delete_selected_product_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.deleteBatch({
						cart_ids: select_id.toString(),
						quantity: 0,
						is_cart: 0,
					}).then((res) => {
						console.log("res.data====");
						this.get_cart_list()
					}).catch((error) => {
						console.log(error.msg);
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch(() => {

				});
			},
			// 清空购物车
			clearCart() {
				if (this.selected_count == 0) {
					this.$message({
						message: this.langInfo.cart_select_tip,
						type: 'warning'
					})
					return

				}
				let select_id = []

				if (this.otherTable.length > 0) {
					this.otherTable.forEach((item, index) => {
						select_id.push(item.id)
					})
				}

				this.$confirm(this.langInfo['sure_clear_cart'], this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.deleteBatch({
						cart_ids: select_id.toString(),
						quantity: 0,
						is_cart: 0,
					}).then((res) => {
						console.log("res.data====");
						this.get_cart_list()
					}).catch((error) => {
						console.log(error.msg);
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch(() => {

				});
			},
			// 结算
			buy_now_btn() {
				if (this.selected_count == 0) {
					this.$message({
						message: this.langInfo.cart_select_tip,
						type: 'warning'
					})
					return

				}
				this.getSelectedItems()

				this.$api.paySelected({}).then((res) => {
					console.log("购物车创建订单====");
					console.log(res);
					this.orderInfo = res.data
					this.payVisible = true

					this.getPayOrderByOrderNo()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 根据订单号查询支付订单详情
			getPayOrderByOrderNo() {
				this.$api.getPayOrderByOrderNo({
					order_no: this.orderInfo.order_no
				}).then((res) => {
					console.log("根据订单号查询支付订单详情====");
					console.log(res);
					this.order_id = res.data.orders[0].id
					this.pay_order = res.data.pay_order
					this.calculateAmount()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 获取选择的购物车商品
			getSelectedItems() {
				this.$api.getSelectedItems({}).then((res) => {
					console.log("选中的购物车商品");
					console.log(res);
					this.paySelectProduct = res.data.list
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			balanceClick(type) {
				this.isBalance = type
				this.calculateAmount()
			},
			// 计算金额接口
			calculateAmount() {
				this.$api.calculateAmount({
					pay_order_id: this.orderInfo.pay_order_id,
					is_pay_money: this.isBalance,
					coupon: this.payInfo.couponCode,
					invitation_code: this.payInfo.invitationCode
				}).then((res) => {
					console.log(res);
					this.pay_price = res.data.pay_price
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			// 优惠券
			couponChange(e) {
				console.log(e);
				this.payInfo.couponCode = e
				this.calculateAmount()
			},
			// 邀请码
			inviteCodeChange(e) {
				this.payInfo.invitationCode = e
				this.calculateAmount()
			},
			// 下一步
			nextPay() {
				if (this.payMethod == 5) {
					// 线下支付
					this.$api.pay({
						payment: "pc",
						pay_order_id: this.orderInfo.pay_order_id,
						payment_type: this.payMethod,
						is_pay_money: this.isBalance,
						coupon: this.payInfo.couponCode,
						invitation_code: this.payInfo.invitationCode
					}).then((res) => {
						console.log(res);
						this.get_cart_list()
						this.$message({
							message: res.msg,
							type: 'success'
						})
						
						
						this.payVisible = false
						
						setTimeout(() => {
							this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
						}, 900)
						
					}).catch((error) => {
						this.get_cart_list()
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				} else {

					if (this.isBalance == 1 && this.pay_price == 0) {
						this.$api.pay({
							payment: "pc",
							pay_order_id: this.orderInfo.pay_order_id,
							payment_type: this.payMethod,
							is_pay_money: this.isBalance,
							coupon: this.payInfo.couponCode,
							invitation_code: this.payInfo.invitationCode
						}).then((res) => {
							console.log(res);
							this.get_cart_list()
							this.$message({
								message: this.langInfo['Payment successful'] ,
								type: 'success'
							})
							this.payVisible = false
							
							setTimeout(() => {
								this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
							}, 900)
							
						}).catch((error) => {
							this.get_cart_list()
							this.$message({
								message: error.msg,
								type: 'warning'
							})
							this.payVisible = false
						})
					} else {
						if (this.payMethod == 1) {
							this.$api.pay({
								payment: "pc",
								pay_order_id: this.orderInfo.pay_order_id,
								payment_type: this.payMethod,
								is_pay_money: this.isBalance,
								coupon: this.payInfo.couponCode,
								invitation_code: this.payInfo.invitationCode
							}).then((res) => {
								console.log(res);
								this.qrcode = res.data.qrcode
								this.wxPay = true

								this.jieguo = setInterval(() => {
									this.getOrderDetail()
								}, 2000)

								this.payVisible = false
							}).catch((error) => {
								this.payVisible = false
							})

						} else {
							this.isAlipay = true

							let payLocation =
								'https://app.51exampass.comapi/v1.pay/pay?server=1&payment=pc&pay_order_id=' + this
								.orderInfo.pay_order_id + '&payment_type=' + this.payMethod + '&is_pay_money=' + this
								.isBalance +
								'&coupon=' +
								this.payInfo.couponCode + '&invitation_code=' + this.payInfo.invitationCode +
								'&user_token=' +
								localStorage.getItem('token')

							window.open(payLocation, '_blank')
							
							this.jieguo = setInterval(() => {
								this.getOrderDetail()
							}, 2000)


							// this.payInfo = {
							// 	remarks: '', //备注，
							// 	couponCode: '', //优惠券码
							// 	invitationCode: '', //邀请码
							// 	pay_money: '' //余额抵扣
							// }
							// this.payVisible = false
						}
					}
				}


			},
			getOrderDetail() {

				this.$api.order_detail({
					id: this.order_id,
				}).then((res) => {
					console.log(res.data);
					if (res.data.payment_status == 1) {
						this.get_cart_list()
						this.order_id = ""
						// 已支付
						this.wxPay = false
						clearInterval(this.jieguo)
						this.jieguo = null

						this.$message({
							message: this.langInfo['Payment successful'],
							type: 'success'
						})
						
						setTimeout(() => {
							this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
						}, 900)
						
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},

			closeWxDialog() {
				clearInterval(this.jieguo)
				this.jieguo = null
				this.$api.order_detail({
					id: this.order_id,
				}).then((res) => {
					console.log(res.data);
					if (res.data.payment_status != 1) {

						this.order_id = ""
						this.qrcode = ''
						// 已支付
						this.wxPay = false
						clearInterval(this.jieguo)
						this.jieguo = null

						this.get_cart_list()

						this.$message({
							message: this.langInfo['Payment failed'],
							type: 'success'
						})
					}

				}).catch((error) => {
					this.get_cart_list()
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},

			closeDialog() {
				this.payInfo = {
					remarks: '', //备注，
					couponCode: '', //优惠券码
					invitationCode: '', //邀请码
					pay_money: '' //余额抵扣
				}
				this.payVisible = false
				this.get_cart_list()

				if (this.payMethod == 2 && this.isBalance == 2 && this.isAlipay) {
					this.isAlipay = false

					this.$api.order_detail({
						id: this.order_id,
					}).then((res) => {
						console.log(res.data);
						if (res.data.payment_status == 1) {
							this.$message({
								message: this.langInfo['Payment successful'],
								type: 'success'
							})

						} else {
							this.$message({
								message: this.langInfo['Payment failed'],
								type: 'success'
							})
						}

					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})


				}


			},

		}
	}
</script>

<style scoped>
	.formInput {
		border: none;
		background-color: transparent;
	}

	.formInput::placeholder {
		color: #A6A6A6;
		/* 例如，设置为灰色 */
	}

	/deep/.el-dialog--center {
		background-color: #F9F9F9;
	}

	/deep/.el-checkbox__inner {
		width: 20px;
		height: 20px;
	}

	/deep/.el-checkbox__inner::after {
		height: 10px;
		left: 6px;
		width: 5px
	}

	/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
		top: 7px
	}

	/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #FD7287;
		border-color: #FD7287;
	}

	/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #FD7287 !important;
		border-color: #FD7287 !important;
	}


	/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #FD7287;
	}

	/deep/.el-checkbox__input .el-checkbox__inner:hover {
		border-color: #FD7287;
	}

	/deep/.el-table th.el-table__cell {
		text-align: center;
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -6px;
		left: 50%;
		transform: translateX(-50%);
	}

	.navTitle:nth-last-child(1) {
		margin-right: 0;
	}

	/deep/.el-input__inner {
		border: 0;
	}

	/deep/.el-input__inner::placeholder {
		color: #b8b8b8;
	}
</style>